/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import Cookies from 'js-cookie';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import { Checkout } from '../components/checkout/checkout.jsx';

export class RegistrationCheckoutController {
      // Initialize this instance of the controller
      //
      // is_modal_container is true when this instance is responsible for hosting the modal, and auto opening
      // coordinator should be an instance of CheckoutModalCoordinator
      constructor(container, event_id, is_modal_container, coordinator = null) {
        let cart_id; let initial_mode; let m; let order_cookie_data; let order_id;
        if (is_modal_container == null) { is_modal_container = true; }
        this.container = container;
        const $container = $(this.container);
        this.event_id = event_id;

        const data = $container.data('ticket-data');

        // Extract initial state from the URL
        if ((m = location.hash.match(/checkout=([a-z0-9]+)/))) {
          initial_mode = m[1];
        } else {
          initial_mode = null;
        }

        // Grab info from the URL to display confirmation or refund component
        // param ticket_id [Integer] single ticket
        // param order_id [Integer] multiple tickets (purchaser only)
        // param Token [String] the corresponding token for the ticket or order requested
        const params = new URLSearchParams(window.location.hash.substring(1));

        // Flag to automatically start the checkout process; used for post-signin flow
        // Only activates if this button's event id matches the page's event id
        let open_checkout = is_modal_container &&
          (event_id.toString() === Slzr.Meta['event-id']) && // toString because meta parses as a string
          params.has("tickets");
          
        // If the marker cookie for a successful payment is present, request a finalize and dispatch of the completed order
        if (Cookies.get(`completed_order_${data.event_id}`)) {
          console.log('got order complete cookie', `completed_order_${data.event_id}`, Cookies.get(`completed_order_${data.event_id}`));
          order_cookie_data = Cookies.get(`completed_order_${data.event_id}`);
          [order_id, cart_id] = Array.from(order_cookie_data.split('|', 2));

          // Clear the cookie
          Cookies.remove(`completed_order_${data.event_id}`);
          // Set the order id
          data['completed_ticket_order_id'] = order_id;
          data['completed_ticket_order_cart_id'] = cart_id;
        }

        // If the marker cookie for a failed payment is present, request a payment retry
        if (Cookies.get(`payment_failed_${data.event_id}`)) {
          order_cookie_data = Cookies.get(`payment_failed_${data.event_id}`);
          [order_id, cart_id] = Array.from(order_cookie_data.split('|', 2));
          console.log("got payment failed cookie", `payment_failed_${data.event_id}`, order_cookie_data);

          // Clear cookie
          Cookies.remove(`payment_failed_${data.event_id}`);

          // Set flags for reopening checkout behavior
          open_checkout = true;
          data['order_id'] = order_id;
          data['cart_id'] = cart_id;
        }

        const params_mode = params.has("refund") ?
                        'refund'
                      : params.has("confirm") ?
                        'confirm'
                      :
                        null;

        if (params_mode) {
          open_checkout = true;
          data[params_mode] = true;
          data['order_id'] = params.get("order_id");
          data['ticket_id'] = params.get("ticket_id");
          data['token'] = params.get("token");
        }

        const checkout_button_classes = $container.data('ticket-checkout-button-class');
        if (checkout_button_classes) {
          data['checkoutButtonClassName'] = checkout_button_classes;
        }

        // If this is the modal container, create and append a div to body, and use that for the overlay
        const modal_container = document.createElement('div');
        if (is_modal_container) { document.body.appendChild(modal_container); }

        // Don't activate React if a login is needed
        if (!data.need_login) {
          this.react_element = ReactDOM.render(
            <Checkout initialMode={initial_mode}
                       openCheckout={open_checkout}
                       modalCoordinator={coordinator}
                       modalContainerElement={modal_container}
                       isModalContainer={is_modal_container}
                       {...data} />,
           container);
        }
      }
    }
